import { gql, useApolloClient } from '@apollo/client';

import { Document } from '@work4all/models/lib/Classes/Document.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/document-table-schema.json';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

export function DocumentsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<Document, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    forceRequestFields: {
      childDocuments: [{ id: null }],
    },
  });

  const client = useApolloClient();

  const handleRowDoubleClick = async (id: string | number) => {
    if (dataTable.selectedEntity?.childDocuments?.length) {
      return;
    }

    const documentFspQueryResponse = await client.query({
      fetchPolicy: 'no-cache',
      query: GET_DOCUMENT_WITH_FSP,
      variables: {
        filter: JSON.stringify([{ code: { $eq: id } }]),
      },
    });

    const documentFspQueryUrl =
      documentFspQueryResponse?.data?.getDokument?.data?.[0]?.fileInfos
        ?.fileServiceProviderInfos?.fspUrl;

    // If there's fsp document data, open the URL in a new tab
    if (documentFspQueryUrl) {
      window.open(documentFspQueryUrl, '_blank');
    }
  };

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      onRowDoubleClick={(id) => {
        handleRowDoubleClick(id);
        return false;
      }}
    />
  );
}

const GET_DOCUMENT_WITH_FSP = gql`
  query GetDokument($filter: String) {
    getDokument(filter: $filter) {
      data {
        code
        fileInfos {
          fileServiceProviderInfos {
            fspUrl
            id
          }
        }
      }
    }
  }
`;
